"use es6";

const isKeyframesTarget = v => {
  return Array.isArray(v);
};
export { isKeyframesTarget };